import styled from 'styled-components';
import {
  COLOR_ORANGE,
  COLOR_RED,
  COLOR_GREEN,
  COLOR_LIGHTER_GREY,
} from '../../../../assets/styles/colors';
import { rgba } from 'polished';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: 1px solid rgba(247, 147, 30, 0.4);
  border-radius: 12px;
  background-color: rgba(247, 147, 30, 0.1);
  color: #bdbdbd;
  outline: none;
  cursor: pointer;
  &.active {
    border: 1px solid rgba(247, 147, 30, 1);
  }
  &.success {
    border: 1px solid ${COLOR_GREEN};
    background-color: ${rgba(`${COLOR_GREEN}`, 0.1)};
    span {
      color: ${COLOR_GREEN};
    }
  }
  &.error {
    border: 1px solid ${COLOR_RED};
  }
  &:hover {
    span {
      text-decoration: none;
    }
  }
  span {
    color: ${COLOR_ORANGE};
    font-size: 18px;
    text-decoration: underline;
    background: none;
    outline: none;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      text-decoration: none;
    }
    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
    svg {
      margin-right: 10px;
      min-width: 22px;
    }
  }
`;

export const FileThumbSC = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0px;
  .image-wrap {
    border-radius: 12px;
    max-width: 170px;
    width: 170px;
    height: 83px;
    object-fit: cover;
    overflow: hidden;
    &.pdf {
      background: ${COLOR_LIGHTER_GREY};
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        min-width: 35px;
        width: 35px;
        height: auto;
      }
    }
    img {
      width: 100%;
    }
  }
  .action-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 170px);
    button,
    span {
      cursor: pointer;
      border: none;
      background: none;
      color: ${COLOR_RED};
      svg {
        margin-left: 7px;
      }
    }
  }
`;
